import React from "react"

import { HashLoader, RingLoader, RotateLoader } from "react-spinners";
import PuffLoader from "react-spinners/PuffLoader";
import PulseLoader from "react-spinners/PulseLoader";
import GridLoader from "react-spinners/GridLoader"

export default function LoadingSpinner( props ) {

  const type = props.type === undefined ? 'default' : props.type;

  const DefaultSpinner = () => {
    const ldsRingStyle = {
      display: 'inline-block',
      position: 'relative',
      width: props.width,
      height: props.height,
    }
  
    const ldsRingDiv = {
      boxSizing: 'border-box',
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: '100%',
      border: '4px solid ' + props.color,
      borderRadius: '50%',
      animation: 'ldsRing 1.3s cubic-bezier(0.5, 0, 0.5, 1) infinite',
      borderColor: props.color + ' transparent transparent transparent'
    }
    const ldsRingDivOne = {
      ldsRingDiv,
      animationDelay: '-0.45s'
    }
    const ldsRingDivTwo = {
      ldsRingDiv,
      animationDelay: '-0.3s'
    }
    const ldsRingDivThree = {
      ldsRingDiv,
      animationDelay: '-0.15s'
    }


    return (
      <div style={{display: 'flex'}} >
      <style>
        {
          `
          @keyframes ldsRing {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }`
        }
      </style>
      <div style={ldsRingStyle} >
        <div style={ldsRingDiv} />
        <div style={ldsRingDivOne} />
        <div style={ldsRingDivTwo}></div>
        <div style={ldsRingDivThree}></div>
        
      </div>
      {props.children}
    </div>
    )
  }

  const PuffLoaderStyle = () => {

    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%'}} >
        <PuffLoader color={props.color} />
      </div>
    )
  }

  const DotPulseStyle = () => {

    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%'}} >
        <PulseLoader size="6px" color={props.color} />
      </div>
    )
  }

  const RingStyle = () => {

    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%'}} >
        <RingLoader size="30px" color={props.color} />
      </div>
    )
  }

  const GridStyle = () => {

    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%'}} >
        <GridLoader size="14px" color={props.color} />
      </div>
    )
  }

  const RotateStyle = () => {

    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%'}} >
        {props.children}
        <RotateLoader size="14px" color={props.color} />
      </div>
    )
  }

  const HashStyle = () => {

    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%'}} >
        {props.children}
        <HashLoader size="24px" color={props.color} />
      </div>
    )
  }


  return (
    <>
    { type === 'default' ? <DefaultSpinner /> : null }
    { type === 'pulse' ? <PuffLoaderStyle /> : null }
    { type === 'dotpulse' ? <DotPulseStyle /> : null  }
    { type === 'ring' ? <RingStyle /> : null  }
    { type === 'grid' ? <GridStyle /> : null  }
    { type === 'rotate' ? <RotateStyle /> : null  }
    { type === 'hash' ? <HashStyle /> : null  }
    </>
  )
}